export default "__VITE_ASSET__NmevNY4W__"